export const WORKSPACE_MODE_QUERY_KEY = 'view';
export const WORKSPACE_MODE_CHANGE_EVENT = 'workspace-mode:change';

export const WORKSPACE_MODES = ['canvas', 'focus', 'conversation'] as const;

export type WorkspaceMode = (typeof WORKSPACE_MODES)[number];

export function isWorkspaceMode(value: string | null | undefined): value is WorkspaceMode {
  return value === 'canvas' || value === 'focus' || value === 'conversation';
}

export function resolveWorkspaceMode(value: string | null | undefined): WorkspaceMode {
  if (value === 'gallery') return 'focus';
  return isWorkspaceMode(value) ? value : 'canvas';
}

export function buildWorkspaceModeHref(
  pathname: string,
  currentSearchParams: URLSearchParams | Readonly<URLSearchParams>,
  mode: WorkspaceMode,
): string {
  const nextSearchParams = new URLSearchParams(currentSearchParams.toString());
  nextSearchParams.set(WORKSPACE_MODE_QUERY_KEY, mode);
  const nextSearch = nextSearchParams.toString();
  return nextSearch ? `${pathname}?${nextSearch}` : pathname;
}
